import React, { useEffect, useState } from 'react';
import TableHeader from './TableParts/TableHeader';
import TableFooter from './TableParts/TableFooter';
import TableBody from './TableParts/TableBody';
import Filters from './Filters';
import TableDiscount from './TableParts/TableDiscount';
import { connect } from 'react-redux';
import { cartCartSelector, cartMainProduct, cartTotal } from '../redux/selectors/cartSelector';
import { includeExtra } from '../redux/actions/cartAction';
import { useFilters } from '../hooks/useFilters';
import useTotal from '../hooks/useTotal';
import useTotalDiscount from '../hooks/useTotalDiscount';
import getDiscountAmountByProduct from '../resolvers/getDiscountAmountByProduct';
import { pagesTariffsByProductSelector } from '../redux/selectors/pagesSelectors';
import { productCurrentProductIdSelector } from '../redux/selectors/productSelector';
import { setPageSubtitle } from '../redux/actions/pagesActions';

function CommonProductList({
    cart,
    cartMainProduct,
    includeExtra,
    mainProduct,
    tariffListByProduct,
    productCurrentProductId,
    setSubtitle,
}) {
    useFilters(cartMainProduct, cartMainProduct?.product_id);
    const productTotal = useTotal(cartMainProduct?.product_id);
    const productDiscount = useTotalDiscount(cartMainProduct?.product_id);
    const [services, setServices] = useState(0);

    useEffect(() => {
        if (
            mainProduct?.current_tariff_id &&
            tariffListByProduct[mainProduct?.current_tariff_id] &&
            tariffListByProduct[mainProduct?.current_tariff_id].services
        ) {
            setServices(tariffListByProduct[mainProduct?.current_tariff_id].services);
        }
    }, [mainProduct, tariffListByProduct]);

    return (
        <section
            className={`section--table section--table--${cart?.currency?.currency?.toLowerCase()}`}
        >
            <Filters product_id={cartMainProduct?.product_id} product={cartMainProduct} />
            <TableHeader />
            <TableBody
                product_id={cartMainProduct?.product_id}
                product={cartMainProduct}
                currency={cart?.currency}
                includeExtra={includeExtra}
            />
            {(getDiscountAmountByProduct(cartMainProduct) > 0 ||
                cartMainProduct?.bonus_amount > 0) && (
                <TableDiscount
                    product_id={cartMainProduct?.product_id}
                    product={cartMainProduct}
                    currency={cart?.currency}
                    services={services}
                    productCurrentProductId={productCurrentProductId}
                    setSubtitle={setSubtitle}
                />
            )}
            <TableFooter
                product={cartMainProduct}
                product_id={cartMainProduct?.product_id}
                total={productTotal}
                discount={productDiscount}
                boltPrice={true}
            />
        </section>
    );
}

const mapStateToProps = (state) => ({
    cart: cartCartSelector(state),
    mainProductTotal: cartTotal(state),
    cartMainProduct: cartMainProduct(state),
    mainProduct: cartMainProduct(state),
    tariffListByProduct: pagesTariffsByProductSelector(state),
    productCurrentProductId: productCurrentProductIdSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    includeExtra: (value) => dispatch(includeExtra(value)),
    setSubtitle: (value) => dispatch(setPageSubtitle(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommonProductList);
